<section id="section05">

    <div class="container">

        <div class="section-header">
            <h2>{{ data.TITULO }}</h2>
            <h4>{{ data.DESCRICAO }}</h4>
        </div>

        <div id="carouselSection05" class="carousel slide w-100" data-ride="carousel">

            <ol class="carousel-indicators">
                <li *ngFor="let case of data.CASES; let index = index" data-target="#carouselSection05"
                    [attr.data-slide-to]="index" [ngClass]="{ 'active': index == 0 }"></li>
            </ol>

            <div class="carousel-inner">

                <div *ngFor="let case of data.CASES; let index = index" class="carousel-item"
                    [ngClass]="{ 'active': index == 0 }">
                    <div class="card">
                        <div class="card-body p-0">
                            <div class="row">
                                <div class="col-lg-5 d-flex justify-content-center align-items-stretch">
                                    <img class="img-fluid" src="{{ case.IMAGEM.URL }}"
                                        alt="{{ case.IMAGEM.DESCRICAO }}">
                                </div>
                                <div class="col-lg-7 p-4">
                                    <h6 class="font-weight-bold text-info">{{ case.TITULO }}</h6>
                                    <h3>{{ case.SUBTITULO }}</h3>
                                    <p>{{ case.DESCRICAO }}</p>

                                    <button class="btn btn-sm btn-link"  [routerLink]="[ case.BOTAO.URL ] | localize">{{ case.BOTAO.TEXTO }} <i
                                            class="fa fa-angle-right ml-2"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <a class="carousel-control-prev" href="#carouselSection05" role="button" data-slide="prev">
                <i class="fa fa-angle-left fa-2x" aria-hidden="true"></i>
                <span class="sr-only">Previous</span>
            </a>

            <a class="carousel-control-next" href="#carouselSection05" role="button" data-slide="next">
                <i class="fa fa-angle-right fa-2x" aria-hidden="true"></i>
                <span class="sr-only">Next</span>
            </a>

        </div>

    </div>

</section>